import Vue from 'vue';
import Vuex from 'vuex';
import { HttpFRONT, HttpGEO, HttpYULI } from '../share';

Vue.use(Vuex);

const state = {
    isInitStatus: false,
    showLoading: false,
    searchIdentifier: {
        _id: '',
        code: '',
        name: '',
        countryCode: '',
        number: '',
    },
    searchResult: null,
    currentUser: null,
    currentComponent: 'register-search',
    currentUserIdentity: null,
    selectedPersonRol: '',
    personInfo: {
        names: '',
        lastNames: '',
        email: '',
    },
    identityTypes: [],
    countries: [],
    roles: [],
    config: {
        app: {},
        invalidDomains: '',
    },
    contacts: [],
    faqSections: [],
    starredFaqs: [],
};

export default new Vuex.Store({
    state,
    mutations: {
        setIdentityTypes (state, value) {
            state.identityTypes = value;
        },
        setCountries (state, value) {
            state.countries = value;
        },
        setRoles (state, value) {
            state.roles = value;
        },
        setSelectedPersonRol (state, value) {
            if (state.selectedPersonRol !== value) {
                state.personInfo = {
                    names: '',
                    lastNames: '',
                    email: '',
                };
            }
            state.selectedPersonRol = value;
        },
        setPersonInfo (state, value) {
            state.personInfo = value;
        },
        setShowLoading (state, value) {
            state.showLoading = value;
        },
        setSearchIdentifier (state, searchIdentifier) {
            if (JSON.stringify(state.searchIdentifier) !== JSON.stringify(searchIdentifier)) {
                state.selectedPersonRol = '';
                state.personInfo = {
                    names: '',
                    lastNames: '',
                    email: '',
                };
                state.currentUser = null;
                state.currentUserIdentity = null;
                state.searchResult = null;
            }

            state.searchIdentifier = searchIdentifier;
        },
        setSearchResult (state, result) {
            state.searchResult = result;
        },
        setCurrentUser (state, user) {
            if (state.currentUser !== user) {
                state.currentUserIdentity = null;
                state.personInfo = {
                    names: '',
                    lastNames: '',
                    email: '',
                };
            }
            state.currentUser = user;
        },
        setCurrentComponent (state, component) {
            state.currentComponent = component;
        },
        setCurrentUserIdentity (state, identity) {
            state.currentUserIdentity = identity;
        },
        setConfig (state, config) {
            state.config = config;
        },
        InitStatus (state) {
            state.isInitStatus = true;
        },
        logout (state) {
            state.isInitStatus = false;
        },
        setContacts (state, contacts) {
            state.contacts = contacts;
        },
        setFaqSections (state, faqSections) {
            state.faqSections = faqSections;
        },
        setStarredFaqs (state, starredFaqs) {
            state.starredFaqs = starredFaqs;
        },
    },
    actions: {
        async InitStatus ({ commit, dispatch }) {
            await dispatch('getConfig');
            commit('InitStatus');
        },
        cleanCurrentUser ({ commit }) {
            commit('setCurrentUser', null);
        },
        logout ({ commit }) {
            return new Promise((resolve, reject) => {
                commit('logout');
                resolve();
            });
        },
        async getConfig ({ commit }) {
            const config = await HttpFRONT.get('/config');
            commit('setConfig', config.data);
        },
        async getCountries ({ commit }) {
            if (this.state.countries.length > 0) {
                return this.state.countries;
            } else {
                const response = await HttpGEO.get('countries?_limit=250&_order=name_iso');
                commit('setCountries', response.data.results);
                return response.data.results;
            }
        },
        async getIdentityTypes ({ commit }, countryCode) {
            // Dictionary of identity types for each country, if already exists in the state, return it.
            const identityTypes = this.state.identityTypes[countryCode];
            if (identityTypes?.length > 0) {
                return identityTypes;
            } else {
                const response = await HttpGEO.get(`countries/${countryCode}/identity_types`);
                this.state.identityTypes[countryCode] = response.data.results;
                return response.data.results;
            }
        },
        async getRoles ({ commit }) {
            if (this.state.roles.length > 0) {
                return this.state.roles;
            } else {
                const response = await HttpYULI.get('/v2/uncprofiles');
                commit('setRoles', response.data);
                return response.data;
            }
        },
        clearSharedComponentsInfo () {
            this.state.searchIdentifier = {
                _id: '',
                code: '',
                name: '',
                countryCode: '',
                number: '',
            };
            this.state.selectedPersonRol = '';
            this.state.personInfo = {
                names: '',
                lastNames: '',
                email: '',
            };
            this.state.searchResult = null;
            this.state.currentUser = null;
            this.state.currentUserIdentity = null;
        },
    },
    getters: {
        nextStep: state => state.searchResult?.nextStep,
        users: state => {
            return state.searchResult?.users;
        },
        configApp: state => {
            return state.config && state.config.app;
        },
        invalidDomains: state => {
            return state.config && state.config.invalidDomains;
        },
        contacts: state => {
            return state.contacts;
        },
        faqSections: state => {
            return state.faqSections;
        },
        starredFaqs: state => {
            return state.starredFaqs;
        },
        sharedComponentsInfo: state => {
            return {
                // register-search
                countryCode: state.searchIdentifier?.countryCode,
                identityType: state.searchIdentifier?.code,
                identityNumber: state.searchIdentifier?.number,
                // register-search-results
                currentUser: state.currentUser,
                // register-person-rol
                selectedPersonRol: state.selectedPersonRol,
                // register-person-form
                names: state.personInfo?.names,
                lastNames: state.personInfo?.lastNames,
                email: state.personInfo?.email,
            };
        },
    },
    modules: {
    },
});
